
import { AlertCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ErrorStateProps {
  message: string;
  onRetry?: () => void;
}

const ErrorState = ({ message, onRetry }: ErrorStateProps) => (
  <div className="flex flex-col items-center justify-center py-12">
    <div className="rounded-full bg-red-100 p-3">
      <AlertCircle className="h-6 w-6 text-red-500" />
    </div>
    <p className="mt-4 text-gray-700">{message}</p>
    {onRetry && (
      <Button className="mt-4" onClick={onRetry}>
        Tentar novamente
      </Button>
    )}
  </div>
);

export default ErrorState;
